import { io } from 'socket.io-client';

import { SOCKET_URL } from 'helpers/env';

export const initSocket = () =>
  io(SOCKET_URL, {
    autoConnect: false,
    transports: ['websocket'],
  });
